import React from "react";

import { Tag, TagLabel, TagProps } from "@chakra-ui/react";

import { Link } from "../wombat-ui";

import { getGroupColor } from "../../utils/colors";
import { GroupFragment } from '../../graphql/generated/definitions';

type GroupTagProps = TagProps & {
  group: GroupFragment;
  disabled?: boolean;
};

const GroupTag: React.FC<GroupTagProps> = ({
  children,
  group,
  disabled = false,
  ...props
}) => {
  return (
    <Tag
      size={"md"}
      variant="solid"
      colorScheme={getGroupColor(group.kind)}
      {...props}
    >
      <TagLabel
        color="currentcolor"
        as={Link}
        to={`/users?groupId=${group.id}`}
        disabled={disabled}
        id={`user_group_${group.id}`}
      >
        {group.name}
      </TagLabel>
      {children}
    </Tag>
  );
};

export default GroupTag;
